/**
 * Inflation-compounded projection.
 * For each year from current year to endYear (inclusive), apply (1 + rate)^(y - currentYear)
 */
export const projectNoMembership = ({
  pricePerNight,
  nightsPerYear,
  inflationRate,
  endYear,
}) => {
  const currentYear = new Date().getFullYear();
  let total = 0;
  const breakdown = [];
  for (let y = currentYear; y <= endYear; y++) {
    const yearsFromNow = y - currentYear;
    const futurePrice = pricePerNight * Math.pow(1 + inflationRate, yearsFromNow);
    const annual = futurePrice * nightsPerYear;
    total += annual;
    breakdown.push({ year: y, annualCost: annual, pricePerNight: futurePrice });
  }
  return { total, breakdown };
};

export const projectWithMembership = ({
  annualFee,
  inflationRate,
  endYear,
}) => {
  const currentYear = new Date().getFullYear();
  let total = 0;
  const breakdown = [];
  for (let y = currentYear; y <= endYear; y++) {
    const yearsFromNow = y - currentYear;
    const futureFee = annualFee * Math.pow(1 + inflationRate, yearsFromNow);
    total += futureFee;
    breakdown.push({ year: y, annualCost: futureFee });
  }
  return { total, breakdown };
};
